export default __webpack_public_path__ + "../staticImages/packster_logo_mobile.png";